import { call, put, takeEvery } from 'redux-saga/effects'
import * as categoryActions from '../ducks/categoryDucks'
import * as categoryApi from '../../api/categoryApi'

interface FetchSaga {
  type: string
  payload: string
}

function* fetchListCategory({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof categoryApi.getListCategory> = yield call(categoryApi.getListCategory, queryString)
    yield put(categoryActions.getListCategorySuccess(res))
  } catch (error) {
    yield put(categoryActions.getListCategoryFail(error))
  }
}

function* fetchListOptionCategory({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof categoryApi.getListOptionCategory> = yield call(categoryApi.getListOptionCategory, queryString)
    yield put(categoryActions.getListOptionCategorySuccess(res))
  } catch (error) {
    yield put(categoryActions.getListOptionCategoryFail(error))
  }
}

function* fetchDetailCategory({ payload: id }: FetchSaga) {
  try {
    const res: ReturnType<typeof categoryApi.getDetailCategory> = yield call(categoryApi.getDetailCategory, id)
    yield put(categoryActions.getDetailCategorySuccess(res))
  } catch (error) {
    yield put(categoryActions.getDetailCategoryFail(error))
  }
}


export default function* watchCategory() {
  yield takeEvery(categoryActions.getListCategory.toString(), fetchListCategory)
  yield takeEvery(categoryActions.getListOptionCategory.toString(), fetchListOptionCategory)
  yield takeEvery(categoryActions.getDetailCategory.toString(), fetchDetailCategory)
}
